import { render, staticRenderFns } from "./Baselines.vue?vue&type=template&id=b8cddabe&"
import script from "./Baselines.vue?vue&type=script&lang=ts&"
export * from "./Baselines.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8cddabe')) {
      api.createRecord('b8cddabe', component.options)
    } else {
      api.reload('b8cddabe', component.options)
    }
    module.hot.accept("./Baselines.vue?vue&type=template&id=b8cddabe&", function () {
      api.rerender('b8cddabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/Baselines.vue"
export default component.exports